/* sts-article-routine.js — the typed article CTA shows the saved routine.
   See docs/new-theme-v4/asset-notes/sts-article-routine.md.

   snippets/sts-article-cta.liquid renders an empty [data-sts-ar] beside the
   Q+ copy of the end-of-article band (never the inline [[ctaquiz]]). When this device holds a saved routine for the reader's type
   (slqSavedRegimen, the copy the home glance and the results page read) the
   block is drawn and the copy is hidden. No routine: the copy stays. */
(function () {
  'use strict';

  var w = window;
  var d = document;
  var STS = (w.STS = w.STS || {});
  if (STS.articleRoutine) return;          // tag printed once per CTA

  var MAX_ROWS = 8;
  var MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
  var SRC = 'article_routine';
  var TYPES = ['DSPT', 'DSNT', 'DSPW', 'DSNW', 'OSPT', 'OSNT', 'OSPW', 'OSNW',
    'ORPT', 'ORNT', 'ORPW', 'ORNW', 'DRPT', 'DRNT', 'DRPW', 'DRNW'];
  var TAG = { AM: 'AM', PM: 'PM', BOTH: '⇆ AM+PM' };

  function lsGet(k) { try { return w.localStorage.getItem(k); } catch (e) { return null; } }
  function parse(raw) { try { return raw ? JSON.parse(raw) : null; } catch (e) { return null; } }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }

  function currentType() {
    var t = (STS.state && STS.state.type) || d.documentElement.getAttribute('data-sts-type') || '';
    t = String(t).toUpperCase();
    return TYPES.indexOf(t) > -1 ? t : null;
  }

  /* Fresh and for THIS type: a cache under another code is someone else's
     routine on a shared device (the rule sts-home.js and sts-steps.js use). */
  function cachedSteps(type, now) {
    var c = parse(lsGet('slqSavedRegimen'));
    if (!c || !Array.isArray(c.steps) || !c.steps.length) return null;
    if (!c.cachedAt || ((now || Date.now()) - c.cachedAt) > MAX_AGE_MS) return null;
    if (type && c.skinType && String(c.skinType).toUpperCase() !== type) return null;
    return c.steps;
  }

  function deviceSteps(type) {
    var pv = typeof STS.previewRoutine === 'function'
      ? STS.previewRoutine().then(function (r) { return r ? r.steps : null; }, function () { return null; })
      : Promise.resolve(null);
    return pv.then(function (steps) { return (steps && steps.length) ? steps : cachedSteps(type); });
  }

  function variantOf(s) {
    var v = s.dtcVariantId || s.variantId || s.variant_id;
    return v ? String(v).split('/').pop() : '';
  }

  function price(s) {
    var p = s.priceMsrp;
    return (p === null || p === undefined || p === '' || !isFinite(Number(p))) ? null : Number(p);
  }

  /* The same test as STSRoutine.core.isBundleAddableStep, so the total and the
     cart add are the same set of bottles. */
  function buyable(s) { return !!variantOf(s) && !!s.title && price(s) !== null && s.inStock !== false; }

  /* Pure: saved steps -> one row per product, AM half first (STS.orderRoutine).
     A product in both halves, or on an AM+PM step, is one row tagged BOTH, in
     the half it first appears in. Steps with no product are not rows. */
  function build(steps) {
    var order = typeof STS.orderRoutine === 'function' ? STS.orderRoutine : function (x) { return x || []; };
    var rows = [];
    var byKey = {};
    order(steps).forEach(function (s) {
      if (!s || typeof s !== 'object' || !s.title) return;
      var v = variantOf(s);
      /* An empty step titled with the eye placeholder, "Eye Cream Specific"
         (STS.stepLabel, sts-state.js), is not a product either. */
      if (!v && STS.stepLabel && STS.stepLabel(s, ['title']) !== String(s.title)) return;
      var key = v ? 'v' + v : s.handle ? 'h' + s.handle : 'i' + s.srcIndex;
      var half = s.half === 'AM' ? 'AM' : 'PM';
      var row = byKey[key];
      if (row) {
        if (row.half !== half || s.time === 'BOTH') row.tag = 'BOTH';
        return;
      }
      row = byKey[key] = { step: s, half: half, tag: s.time === 'BOTH' ? 'BOTH' : half };
      rows.push(row);
    });
    var total = 0;
    var units = [];
    var unavailable = 0;
    rows.forEach(function (r) {
      if (buyable(r.step)) { units.push(r.step); total += price(r.step); } else if (r.step.inStock === false) unavailable++;
    });
    return { rows: rows, units: units, total: Math.round(total * 100) / 100, unavailable: unavailable };
  }

  function money(n) {
    var R = w.STSRoutine;
    if (R && R.money && typeof R.money.format === 'function') return R.money.format(n);
    /* v6.1 13.3: the head's STS.money, with the routine totals' house style. */
    return STS.money ? STS.money.format(n, { trim: true }) : '$' + Number(n).toFixed(2);
  }

  /* v6.1 13.3: the device copy carries the backend's US prices; outside the
     shop's currency each step is repriced from the market's own price list. */
  function mkt(L) {
    var M = STS.money, F = STS.stepFallback;
    /* QA 2026-10-01: the live store price, at home too (sts-step-fallback.js). */
    if (L && F && F.prices) return F.prices(L);
    return L && M && M.reprice && M.code() !== M.shop ? M.reprice(L) : L;
  }

  function el(tag, cls, text) {
    var n = d.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }

  function sized(src) {
    var u = String(src);
    if (u.indexOf('cdn.shopify.com') < 0 || /[?&]width=/.test(u)) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=96';
  }

  function hrefOf(s) {
    if (s.url) return s.url;
    return s.handle ? '/products/' + String(s.handle).replace(/^\/+/, '') : null;
  }

  function rowNode(r) {
    var s = r.step;
    var row = el('div', 'sts-ar__row' + (s.inStock === false ? ' is-oos' : ''));
    row.setAttribute('role', 'listitem');
    var src = s.image || s.imageUrl || s.image_url;
    var thumb = el('span', 'sts-ar__thumb');
    if (src) {
      var img = el('img', 'sts-ar__img');
      img.src = sized(src);
      img.alt = s.title || '';
      img.width = 48;
      img.height = 48;
      img.loading = 'lazy';
      img.decoding = 'async';
      thumb.appendChild(img);
    }
    row.appendChild(thumb);
    var text = el('span', 'sts-ar__text');
    if (s.brand) text.appendChild(el('span', 'sts-ar__brand', s.brand));
    var href = hrefOf(s);
    var name = el(href ? 'a' : 'span', 'sts-ar__name', s.title);
    if (href) { name.href = href; name.setAttribute('data-sts-ar-link', ''); }
    text.appendChild(name);
    row.appendChild(text);
    var side = el('span', 'sts-ar__side');
    var p = price(s);
    side.appendChild(el('span', 'sts-ar__price', s.inStock === false ? 'Unavailable' : (p === null ? '' : money(p))));
    var tag = el('span', 'sts-ar__tag sts-ar__tag--' + r.tag.toLowerCase(), TAG[r.tag]);
    if (r.tag === 'BOTH') tag.setAttribute('aria-label', 'Morning and evening');
    side.appendChild(tag);
    row.appendChild(side);
    return row;
  }

  function octagon(type) {
    var n = TYPES.indexOf(type) + 1;
    var o = el('span', 'sts-oct sts-oct--34 sts-ar__oct');
    o.setAttribute('data-sts-type', type);
    o.setAttribute('role', 'img');
    o.setAttribute('aria-label', 'Baumann Skin Type ' + n + ', ' + type);
    var num = el('span', 'sts-oct__n', String(n));
    num.setAttribute('aria-hidden', 'true');
    o.appendChild(num);
    return o;
  }

  /* ------------------------------------------------------------ assets */

  var cssPromise = null;
  function loadCss(href) {
    if (cssPromise) return cssPromise;
    cssPromise = new Promise(function (resolve, reject) {
      if (!href) { reject(new Error('no css')); return; }
      var link = d.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = resolve;
      link.onerror = reject;
      d.head.appendChild(link);
    });
    return cssPromise;
  }

  var sharedPromise = null;
  function loadShared(src) {
    var R = w.STSRoutine;
    if (R && R.cart && R.core) return Promise.resolve(R);
    if (sharedPromise) return sharedPromise;
    sharedPromise = new Promise(function (resolve, reject) {
      if (!src) { reject(new Error('no cart helper')); return; }
      var s = d.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function () {
        var r = w.STSRoutine;
        if (r && r.cart) resolve(r); else reject(new Error('no cart helper'));
      };
      s.onerror = function () { sharedPromise = null; reject(new Error('no cart helper')); };
      d.head.appendChild(s);
    });
    return sharedPromise;
  }

  /* ---------------------------------------------------------------- add */

  /* /cart/add.js rejects the whole batch for one bad line; then one at a time,
     as the home glance does. STSRoutine.cart.add skips lines already in the
     cart and stamps `_sts_src` on every line it sends. */
  function addAll(CART, items) {
    return CART.add(items, SRC).then(
      function (n) { return { added: n, failed: 0 }; },
      function (err) {
        if (items.length < 2) throw err;
        var added = 0;
        var failed = 0;
        return items.reduce(function (p, item) {
          return p.then(function () {
            return CART.add([item], SRC).then(function (n) { added += n; }, function () { failed += 1; });
          });
        }, Promise.resolve()).then(function () {
          if (failed === items.length) throw err;
          return { added: added, failed: failed };
        });
      });
  }

  function track(params) {
    try { if (typeof w.stsTrack === 'function') w.stsTrack('sts_regimen_add', params); } catch (e) { /* never load bearing */ }
  }

  function onAdd(box, btn, model, label) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var msg = box.querySelector('[data-sts-ar-msg]');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    btn.textContent = 'Adding…';
    msg.textContent = '';
    var planned = 0;
    loadShared(box.getAttribute('data-shared'))
      .then(function (R) {
        var CART = R.cart;
        var items = CART.buildItems(model.units, null);   // no plans: one-time lines
        planned = items.length;
        if (!planned) throw new Error('ALL_OUT');
        return addAll(CART, items).then(function (res) {
          return CART.read().then(function (cart) {
            CART.notifyChanged(cart);
            CART.openDrawer();
            return res;
          });
        });
      })
      .then(function (res) {
        var already = Math.max(0, planned - res.added - res.failed);
        var text = res.added
          ? plural(res.added, 'product', 'products') + ' added to your cart.'
          : 'Everything in your routine is already in your cart.';
        if (res.added && already) text += ' ' + already + (already === 1 ? ' was' : ' were') + ' already there.';
        if (res.failed) text += ' ' + plural(res.failed, 'product', 'products') + ' could not be added.';
        /* A clean add says nothing (v5.1 §1.5): the drawer and the cart count
           show it. The line speaks only when something did not go in. */
        msg.textContent = res.failed ? text : '';
        if (res.added) {
          track({ mode: 'full', surface: SRC, items: res.added, value: res.failed || already ? null : model.total,
            currency: (w.Shopify && w.Shopify.currency && w.Shopify.currency.active) || 'USD', subscribe: false });
        }
      })
      .catch(function (err) {
        var m = String((err && err.message) || err || '');
        if (m === 'no cart helper') { w.location.href = box.getAttribute('data-results-url') || '/pages/skin-type-results'; return; }
        msg.textContent = m === 'ALL_OUT'
          ? 'Everything in your routine is out of stock right now.'
          : 'We could not add your routine to the cart. Please try again.';
      })
      .then(function () {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        btn.textContent = label;
      });
  }

  /* ------------------------------------------------------------- render */

  function draw(box, type, model) {
    var variant = box.getAttribute('data-variant') === 'inline' ? 'p' : 'h2';
    var results = box.getAttribute('data-results-url') || '/pages/skin-type-results';
    var sub = box.parentNode && box.parentNode.querySelector('.sts-article-cta__body');
    box.textContent = '';

    var head = el('div', 'sts-ar__head');
    head.appendChild(octagon(type));
    var headText = el('div', 'sts-ar__head-text');
    var title = el(variant, 'sts-article-cta__title sts-ar__title', (box.getAttribute('data-title') || 'Your routine for skin type') + ' ');
    title.appendChild(el('span', 'sts-ar__code', type));
    headText.appendChild(title);
    if (sub && sub.textContent.trim()) headText.appendChild(el('span', 'sts-ar__sub', sub.textContent.trim()));
    head.appendChild(headText);
    box.appendChild(head);

    var list = el('div', 'sts-ar__list');
    var shown = model.rows.slice(0, MAX_ROWS);
    ['AM', 'PM'].forEach(function (h) {
      var mine = shown.filter(function (r) { return r.half === h; });
      if (!mine.length) return;
      var group = el('div', 'sts-ar__group');
      group.setAttribute('role', 'list');
      group.setAttribute('aria-label', h === 'AM' ? 'Morning' : 'Evening');
      var lab = el('span', 'sts-ar__half', (h === 'AM' ? '☀ ' : '☽ ') + h);
      lab.setAttribute('aria-hidden', 'true');
      list.appendChild(lab);
      mine.forEach(function (r) { group.appendChild(rowNode(r)); });
      list.appendChild(group);
    });
    var more = model.rows.length - shown.length;
    if (more > 0) {
      var m = el('a', 'sts-ar__more', '+' + more + ' more');
      m.href = results;
      m.setAttribute('data-sts-ar-link', '');
      m.setAttribute('data-sts-routine-link', '');
      list.appendChild(m);
    }
    box.appendChild(list);

    var foot = el('div', 'sts-ar__foot');
    var label = 'Add my routine to cart · ' + money(model.total);
    var btn = el('button', 'sts-article-cta__btn sts-ar__add', label);
    btn.type = 'button';
    if (!model.units.length) btn.disabled = true;
    btn.addEventListener('click', function () { onAdd(box, btn, model, label); });
    foot.appendChild(btn);
    var see = el('a', 'sts-ar__see', 'See my full routine →');
    see.href = results;
    see.setAttribute('data-sts-ar-link', '');
    // sts-state.js re-points it on click: the v6.1 1.1 See my routine rule.
    see.setAttribute('data-sts-routine-link', '');
    foot.appendChild(see);
    if (model.unavailable) foot.appendChild(el('span', 'sts-ar__note', plural(model.unavailable, 'item', 'items') + ' unavailable'));
    var status = el('span', 'sts-ar__msg');
    status.setAttribute('role', 'status');
    status.setAttribute('data-sts-ar-msg', '');
    foot.appendChild(status);
    box.appendChild(foot);
  }

  /* The Q+ copy is the box's siblings; the class hides them (sts-article-routine.css). */
  function show(box, on) {
    box.hidden = !on;
    if (box.parentNode) box.parentNode.classList.toggle('is-ar', !!on);
  }

  /* Q+ stale keeps the copy (asset note). */
  function stale() { return d.documentElement.getAttribute('data-sts-state') === 'qstale'; }

  function fill(box) {
    var type = currentType();
    var key = stale() ? 'stale' : type;
    if (box.__stsArType === key) return;
    box.__stsArType = key;
    if (!type || key === 'stale') { show(box, false); return; }
    deviceSteps(type).then(mkt).then(function (steps) {
      if (box.__stsArType !== key) return;            // superseded
      var model = steps && steps.length ? build(steps) : null;
      if (!model || !model.rows.length) { show(box, false); return; }
      loadCss(box.getAttribute('data-css')).then(function () {
        if (box.__stsArType !== key) return;
        draw(box, type, model);
        show(box, true);
        loadShared(box.getAttribute('data-shared')).catch(function () { /* retried on click */ });
      }, function () { show(box, false); });           // unstyled is worse than the copy
    });
  }

  function scan(root) {
    Array.prototype.forEach.call((root || d).querySelectorAll('[data-sts-ar]'), function (box) {
      if (box.closest('template')) return;
      fill(box);
    });
  }

  STS.articleRoutine = { build: build, cachedSteps: cachedSteps };

  if (!d.querySelectorAll) return;
  scan();
  d.addEventListener('sts:state', function () { scan(); });
  /* On Bloggle, assets/article.js clones the [[ctaquiz]] template in later. */
  if (typeof w.MutationObserver === 'function' && d.body) {
    new w.MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var added = list[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.hasAttribute('data-sts-ar') || n.querySelector('[data-sts-ar]'))) { scan(n.parentNode || d); return; }
        }
      }
    }).observe(d.body, { childList: true, subtree: true });
  }
})();
